import fetch from "lib/fetch";
import type FileInterface from "types/file";
import type { FileResponseInterface } from "types/file";
import type { BookingInterface } from "types/booking";

interface BookingListResponse {
    data: Array<BookingInterface>;
    pager: {
        total: number;
        total_page: number;
        last_page: number;
        per_page: number;
        current_page: number;
        order?: string;
        direction?: string;
        custom?: HashMap<number | undefined>;
    };
    filters: HashMap<unknown>;
}

type BookingResponse = { data: BookingInterface };
type UnknownResponse = { data: unknown };
type FileApiResponse = { data: FileResponseInterface };

export const getBookingsRequest = (params?: HashMap<unknown>) =>
    fetch.get<BookingListResponse>("booking", { params });

export const getBookingRequest = (id: string, params?: HashMap<unknown>) =>
    fetch.get<BookingResponse>(`booking/${id}`, { params });

export const getLastBookingsRequest = () => fetch.get<UnknownResponse>("booking/lasts");

export const cancelBookingRequest = (id: string) => fetch.post<BookingResponse>(`booking/${id}/cancel`);

export const downloadBookingSalesSuccessionRequest = (bookingId: string) =>
    fetch.get<FileApiResponse>(`booking/${bookingId}/download_sales_succession`);

export type { FileInterface };
